module.exports = __webpack_public_path__ + "static/media/toCheckGroupIcon.91d83718.svg";